import React, {useEffect} from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const FROM_DATE_KEY = 'fromDate';
const TO_DATE_KEY = 'toDate';


function DataPicker({toDateState, fromDateState, setFromDateState, setToDateState}) {

    useEffect(() => {
        const storedFromDate = localStorage.getItem(FROM_DATE_KEY);
        const storedToDate = localStorage.getItem(TO_DATE_KEY);

        if (storedFromDate && storedToDate) {
            setFromDateState(new Date(storedFromDate));
            setToDateState(new Date(storedToDate));
        } else {
            const today = new Date();
            const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            setToDateState(today);
            setFromDateState(firstDayOfMonth);
        }
    }, [setFromDateState, setToDateState]);

    const handleFromDateChange = (date) => {
        setFromDateState(date);
        localStorage.setItem(FROM_DATE_KEY, date.toISOString());
    };

    const handleToDateChange = (date) => {
        setToDateState(date);
        localStorage.setItem(TO_DATE_KEY, date.toISOString());
    };

    return (
        <div className='labelingHeaderDatePickers'>
            <div className='labelingPickerElem'>
                <p style={{fontSize: '17px', color: '#005773'}}>Start Date -</p>
                <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={fromDateState}
                    onChange={handleFromDateChange}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode='select'
                    minDate={new Date('01-01-2023')}
                    maxDate={new Date()}
                />
            </div>
            <div className='labelingPickerElem' style={{paddingLeft: '15px'}}>
                <p style={{fontSize: '17px', color: '#005773'}}>End Date -</p>
                <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={toDateState}
                    onChange={handleToDateChange}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode='select'
                    minDate={new Date('01-01-2023')}
                    maxDate={new Date()}
                />
            </div>
        </div>
    );
}

export default DataPicker;